import _ from 'lodash';
import {
    FETCH_RAINPRO_POINT_PACKAGES,
    CLEAN_RAINPRO_POINT_PACKAGES,
} from './types';
import { request, __ } from '../functions';

export const fetchRainproPointPackages = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/rainpro/point-packages', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_RAINPRO_POINT_PACKAGES, payload: data });
    });
};

export const cleanRainproPointPackages = () => ({ type: CLEAN_RAINPRO_POINT_PACKAGES });
